import { useGetGeofenceInteractionQuery } from '@customer/store/apis/interactionsApi';
import { useAppSelector } from '@customer/store/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import { useParams } from 'react-router-dom';

// The purpose of this hook is to make it easier to keep the query identical between parent and child components for the sake of caching.
export const useGeofenceInteraction = () => {
  const globalState = useAppSelector(state => state.global);
  const { assetId } = useParams();

  const { currentData: interaction, error } = useGetGeofenceInteractionQuery(
    globalState.sidePanelModelId && assetId
      ? { assetId, interactionId: globalState.sidePanelModelId }
      : skipToken,
    { refetchOnMountOrArgChange: true, refetchOnReconnect: true },
  );

  return {
    interaction,
    error,
  };
};

export default useGeofenceInteraction;
